
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import Pusher from 'pusher-js';

@Injectable()

export class PusherService {

    private endPointUrl = 'http://localhost:8000/pusher/event';

    private appKey = 'ifconfig';
    private secret = 'ifconfig';
    private appId = 'ifconfig';

    private cluster = 'ifconfig';

    private httpHost = 'localhost';
    private httpPort = 8000;
    private httpPath = '';

    private wsHost = 'localhost';
    private wsPort = 6001;
    private wsPath = '';

    public pusher: any;
    public channel: any;

    constructor(private http: HttpClient) {
        this.setConfig();
        this.initPusher();
    }

    public setConfig(): void
    {

    }

    public initPusher(): void
    {

        Pusher.logToConsole = true;

        const options = {
            cluster: this.cluster,
            httpHost: this.httpHost,
            httpPort: this.httpPort,
            httpPath: this.httpPath,
            wsHost: this.wsHost,
            wsPort: this.wsPort,
            wsPath: this.wsPath,
            enabledTransports: ['ws'],
            disabledTransports: ['wss', 'xhr_streaming', 'xhr_polling', 'sockjs'],
            forceTLS: false,
        };
        console.log(options);

        // @ts-ignore
        this.pusher = new Pusher(this.appKey, options);
        this.channel = this.pusher.subscribe('test');
        this.channel.bind('test', (data) => {
            console.log('log-message -> ', data);
        });

        const data = {a: 'test', b: 'message'};
        this.sendData('test', 'test', data);

    }


    public sendData(channel: string, event: string, object: any): void
    {
        const params = {
            key: this.appKey,
            appId: this.appId,
            secret: this.secret,
            channel: channel,
            event: event,
            data: JSON.stringify(object),
        };

        this.http.post(this.endPointUrl, params)
            .subscribe((response) => {
                console.log('MESSAGE SEND -> ', response);
            });
    }



}
